import styled from 'styled-components';

import Text from 'components/UI/atoms/Text';

export const TimeRangeText = styled(Text)``;

export default {};
